import React from 'react';
import WalletConfigIcon from './WalletConfigIcon';
import AddressBookIcon from './AddressBookIcon';
import PollingConfig from './PollingConfig';

/**
 * TopRightBar Component
 * 
 * Standardized top-right bar containing wallet and address book icons.
 * Used consistently across all pages in the GameMaker application.
 */
const TopRightBar = ({
  onWalletDisconnect,
  showInTestMode = false // Control visibility in test mode
}) => {
  // Check if we're in test mode and should hide the bar
  const urlParams = new URLSearchParams(window.location.search);
  const isTestMode = urlParams.get('test') === 'true';

  // Always show WalletConfigIcon in test mode for wallet switching tests
  // but hide AddressBookIcon unless explicitly requested
  const showWalletInTest = isTestMode;
  const showAddressBookInTest = isTestMode && showInTestMode;

  return (
    <div className="flex items-center space-x-3">
      {/* Address Book Icon - hide in test mode unless explicitly requested */}
      {(!isTestMode || showAddressBookInTest) && <AddressBookIcon />}

      {/* Wallet Config Icon - always show in test mode for disconnect testing */}
      {(!isTestMode || showWalletInTest) && (
        <WalletConfigIcon
          onDisconnect={onWalletDisconnect}
        />
      )}

      {/* Polling Config - positioned after wallet icon, always available in production */}
      {(!isTestMode || showInTestMode) && <PollingConfig />}
    </div>
  );
};

export default TopRightBar;